import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md surface p-10" data-testid="login-card">
        <div className="text-[10px] uppercase tracking-widest text-[#CCFF00] font-mono">X1K // Access</div>
        <h1 className="font-display text-3xl font-bold mt-2">{t("login_title")}</h1>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <Field label={t("email")} type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="login-email-input" />
          <Field label={t("password")} type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="login-password-input" />
          <button disabled={loading} data-testid="login-submit-button" type="submit" className="btn-acid w-full">
            {loading ? "…" : t("submit")}
          </button>
        </form>
        <div className="mt-6 text-sm text-white/40 font-mono">
          {t("no_account")} <Link data-testid="login-to-register-link" to="/register" className="text-[#CCFF00] hover:underline">{t("nav_register")}</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest text-white/40 font-mono mb-2">{label}</div>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        className="w-full bg-[#0A0A0A] border border-[#222] focus:border-[#CCFF00] focus:outline-none px-4 py-3 font-mono text-sm transition-colors"
      />
    </label>
  );
}
